export default __webpack_public_path__ + "images/CA.0f247ba.png";